<template>
  <div class="card-wrapper">
    <div :class="cardClasses" @click="onCardClicked">
      <div class="card-top">
        <label class="v2-styled-checkbox">
          <input type="checkbox" :name="inputName" :value="site.id" :checked="checkedValue" @change="onCardClicked" />
          <span class="name" v-text="site.name" />
        </label>
        <div class="card-image-wrapper">
          <div class="card-image-frame">
            <img :src="site.logoUrl" class="card-image" />
          </div>
        </div>
      </div>
      <!-- site.description は管理者が入力するのでXSSは起きない -->
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="description" v-html="site.description" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from '@vue/composition-api';

export type Site = {
  id: number;
  name: string;
  logoUrl: string;
  description: string;
};

const SiteCard = defineComponent({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    site: {
      type: Object as PropType<Site>,
      required: true,
    },
  },
  setup(props, context) {
    const checkedValue = computed({
      get() {
        return props.value;
      },
      set(value: boolean) {
        context.emit('change', { id: props.site.id, checked: value });
      },
    });
    const onCardClicked = () => {
      checkedValue.value = !checkedValue.value;
    };
    const cardClasses = computed(() => (props.value ? ['card'] : ['card', 'unchecked']));
    const inputName = computed(() => `user[site_registrations_attributes][${props.site.id}][cooperating_site_id]`);
    return {
      cardClasses,
      inputName,
      checkedValue,
      onCardClicked,
    };
  },
});

export default SiteCard;
</script>

<style lang="scss" scoped>
@import 'stylesheets/mixins';

.card-wrapper {
  margin-top: 12px;
  word-break: break-all;
  @include media-pc {
    flex: 0 0 50%;
    &:nth-child(even) {
      padding-left: 5px;
    }
    &:nth-child(odd) {
      padding-right: 5px;
    }
  }
}

.card {
  background: white;
  border: 1px solid white;
  border-radius: 2px;
  padding: 14px;
  height: 100%;
  cursor: pointer;

  &.unchecked {
    border: 1px solid red;
  }
}

.card-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-image-wrapper {
  display: inline-block;
}

.card-image-frame {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid $v2-border-color;
  width: 60px;
  height: 60px;
}

.card-image {
  width: 54px;
  height: 54px;
  object-fit: contain;
}

.name {
  user-select: none;
  font-size: 15px;
}

.description {
  margin-top: 8px;
  color: $v2-text-sub-color;
  font-size: 12px;
}
</style>
